import {
  DEFAULT_ZONE_CREATE_FORM,
  ZONE_WIZARD_STEP_IDS,
} from "./zoneSettingsWizard";

const ZONE_CREATE_DRAFT_STORAGE_KEY = "settings-zone-create-draft";

export function clearZoneCreateDraft() {
  try {
    sessionStorage.removeItem(ZONE_CREATE_DRAFT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

function readZoneCreateDraft() {
  try {
    const raw = sessionStorage.getItem(ZONE_CREATE_DRAFT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeZoneCreateDraft({
  formData,
  activeStep,
  maxReachedStepIndex,
}) {
  try {
    sessionStorage.setItem(
      ZONE_CREATE_DRAFT_STORAGE_KEY,
      JSON.stringify({
        formData,
        activeStep,
        maxReachedStepIndex,
        savedAt: Date.now(),
      }),
    );
  } catch {
    /* ignore */
  }
}

export function getInitialZoneCreateState() {
  const draft = readZoneCreateDraft();
  const formData = draft?.formData
    ? { ...DEFAULT_ZONE_CREATE_FORM, ...draft.formData }
    : { ...DEFAULT_ZONE_CREATE_FORM };

  const activeStep =
    draft?.activeStep && ZONE_WIZARD_STEP_IDS.includes(draft.activeStep)
      ? draft.activeStep
      : ZONE_WIZARD_STEP_IDS[0];

  const maxReachedStepIndex =
    typeof draft?.maxReachedStepIndex === "number"
      ? Math.max(
          0,
          Math.min(draft.maxReachedStepIndex, ZONE_WIZARD_STEP_IDS.length - 1),
        )
      : 0;

  return { formData, activeStep, maxReachedStepIndex };
}
